module.exports = __webpack_public_path__ + "media/images/general/not_setting_thumb_1922_1223-a7599abf4a4e692a9238f01d3439b0a7.png";